import { useHookstate } from "@hookstate/core"
import { useEffect } from "react"
import Tick from "../../../assets/icons/Tick"
import { useParams } from "react-router-dom";
import { simpleGetter } from "../../../actions/common";
import { certificateApi } from "../../../api/api";
import { getDateOnly, getHHMMFromDateString } from "../../../misc/utils";

const columns = {
    left: [
        {
            label: 'Наименование учебного заведения',
            getValue: () => 'Казахстанско-Британский технический университет'
        },
        {
            label: 'ID документа',
            getValue: (c: any) => c.id
        },
        {
            label: 'Дата создания',
            getValue: (c: any) => getDateOnly(c.createdAt)
        },
        {
            label: 'ФИО Студента',
            getValue: (c: any) => `${c.student.json_saved_data.lastname || '-'} ${c.student.json_saved_data.firstname || '-'}`
        },
        {
            label: 'Срок обучения (год поступления и год окончания)',
            getValue: (c: any) => c.student.json_saved_data.yearOfStudy
        },
        {
            label: 'Дата выдачи справки',
            getValue: (c: any) => getDateOnly(c.updatedAt)
        },
    ],
    right: [
        {
            label: 'Должность / Фамилия Имя Отчество',
            getValue: (c: any) => `${c.signer.json_saved_data.lastname || '-'} ${c.signer.json_saved_data.firstname || '-'}`
        },
        {
            label: 'Выполненный процесс',
            getValue: (c: any) => 'Подписан'
        },
        {
            label: 'Дата и время',
            getValue: (c: any) => `${getDateOnly(c.updatedAt)} ${getHHMMFromDateString(c.updatedAt)}`
        },
    ]
}

export const CertificateVerify = () => {
    const { code } = useParams();
    const localState = useHookstate<{ certificate: any }>({
        certificate: undefined
    })
    const state = localState.get()
    const getCertificate = async () => {
        const response = await simpleGetter(certificateApi.verify, code)
        if (response.success) {
            localState.merge({
                certificate: response.certificate
            })
        }
    }

    useEffect(() => {
        getCertificate()
    }, [])

    if (!state.certificate) {
        return null;
    }

    return (
        <div className="flex flex-col w-full h-full items-center justify-center">
            <div className="w-full md:w-2/3 h-full flex flex-col gap-6">
                <div className="flex flex-row bg-[#3BBC3014] py-4 justify-center items-center gap-2 rounded-2xl">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21Z" fill="#3BBC30" fill-opacity="0.2" stroke="#3BBC30" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9 12L11 14L15 10" stroke="#3BBC30" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span className="text-[#3BBC30] text-sm leading-6">
                        Документ подлинный
                    </span>
                </div>
                <div className="flex flex-row flex-1 gap-5">
                    <div className="flex flex-col flex-1 gap-3">
                        <span className="font-medium text-xl leading-6 text-valley-light-gray">
                            Данные документа
                        </span>
                        <div className="flex flex-col flex-1 bg-[#F0F3FA80] rounded-2xl p-4 gap-3">
                            {columns.left.map(col => (
                                <div className="flex flex-col gap-1">
                                    <span className="text-xs leading-4 text-valley-gray">
                                        {col.label}
                                    </span>
                                    <span className="text-[15px] font-medium leading-[18px] text-valley-black">
                                        {col.getValue(state.certificate)}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="flex flex-col flex-1 gap-3">
                        <span className="font-medium text-xl leading-6 text-valley-light-gray">
                            Кем подписан
                        </span>
                        <div className="flex flex-col flex-1 bg-[#F0F3FA80] rounded-2xl p-4 gap-3">
                            {columns.right.map(col => (
                                <div className="flex flex-col gap-1">
                                    <span className="text-xs leading-4 text-valley-gray">
                                        {col.label}
                                    </span>
                                    <span className="text-[15px] font-medium leading-[18px] text-valley-black">
                                        {col.getValue(state.certificate)}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="flex flex-row">
                    <a href={state.certificate.filename} target="_blank" className="flex flex-row flex-1 justify-center items-center py-3 bg-valley-main rounded-[100px]">
                        <span className="font-medium text-base leading-6 text-white">
                            Скачать документ
                        </span>
                    </a>
                </div>
            </div>
        </div>
    )
}